import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui-fe/mixins/formMixin';
let AmFeFormElementContainer = class AmFeFormElementContainer extends Mixins(FormMixin) {
  get label_i18n() {
    return this.label === '表单项' ? window.lowcode.i18n.get('apaas_amui_formelementcontainer_label', '表单项') : this.label;
  }
};
AmFeFormElementContainer.componentName = 'AmFeFormElementContainer';
AmFeFormElementContainer = __decorate([Component({
  name: 'AmFeFormElementContainer'
})], AmFeFormElementContainer);
export default AmFeFormElementContainer;